import { module } from 'modujs';
import { lerp } from '../utils/maths';
import { transform } from '../utils/transform';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                wrap: 'enter'
            },
            mouseleave: {
                wrap: 'leave'
            }
        }
    }

    init() {
        if (window.isMobile) return;
        this.mouse = {
            x: 0,
            y: 0,
            lerpedX: 0,
            lerpedY: 0
        }

        this.lerp = 0.12;
        this.hasMoved = false;
        this.bcr = this.el.getBoundingClientRect();
        this.isAvailable = false;
        this.isHover = false;

        this.$label = this.$('label')[0];

        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove', this.bindMousemove);

        this.bindResize = this.resize.bind(this);
        window.addEventListener('mousemove', this.bindResize);

        gsap.delayedCall(1, () => {
            this.resize();
            this.mouse.x = this.bcr.width / 2;
            this.mouse.y = this.bcr.height / 2;
            this.mouse.lerpedX = this.bcr.width / 2;
            this.mouse.lerpedY = this.bcr.height / 2;
            transform(this.$label, `translate3d(${this.bcr.width / 2}px,${this.bcr.height / 2}px,0) translate3d(-50%, -50%, 0)`);
        })
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());


        if (this.isAvailable) {

            this.mouse.lerpedX = lerp(this.mouse.lerpedX, this.mouse.x, this.lerp);
            this.mouse.lerpedY = lerp(this.mouse.lerpedY, this.mouse.y, this.lerp);

            transform(this.$label, `translate3d(${this.mouse.lerpedX}px,${this.mouse.lerpedY}px,0) translate3d(-50%, -50%, 0)`)
        }
    }

    mousemove(e) {
        if (this.isHover) {
            this.mouse.x = e.clientX;
            this.mouse.y = e.clientY - this.bcr.top;
        }
    }

    resize() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.bcr = this.el.getBoundingClientRect();
    }

    enter() {
        if (window.isMobile) return;

        cancelAnimationFrame(this.raf);

        this.isHover = true;
        if (!this.hasMoved) {
            this.hasMoved = true;
            this.el.classList.add('has-moved');
        }
        if (this.leaveCallback !== undefined) {
            this.leaveCallback.kill();
        }
        this.isAvailable = true;

        this.animate();

        this.lerp = 0.06;
        this.enterCallback = gsap.delayedCall(0.8, () => {
            this.lerp = 0.12;
        });
    }

    leave() {
        if (window.isMobile) return;

        this.isHover = false;
        this.mouse.x = this.bcr.width / 2;
        this.mouse.y = this.bcr.height / 2;

        if (this.enterCallback !== undefined) {
            this.enterCallback.kill();
        }

        this.leaveCallback = gsap.delayedCall(0.8, () => {
            this.isAvailable = false;
            cancelAnimationFrame(this.raf);
            this.lerp = 0.12;
        });
    }

    destroy() {
        if (window.isMobile) return;
        window.removeEventListener('mousemove', this.bindMousemove);
        cancelAnimationFrame(this.raf);

    }
}
